// constants for app
export const APP_VERSION = "2.3.9";
export const REFRESH_APP_DATA = "REFRESH_APP_DATA";
export const GET_DEVICE_INFO = "GET_DEVICE_INFO";
export const GET_APP_PREFERENCES = "GET_APP_PREFERENCES";
export const GET_ALL_LOCAL_USERS = "GET_ALL_LOCAL_USERS";
export const GET_ALL_DAFFI_USERS = "GET_ALL_DAFFI_USERS";

export const IS_USER_LOGGED_IN = "IS_USER_LOGGED_IN";
export const IS_DEVICE_INFO_EXISTS = "IS_DEVICE_INFO_EXISTS";

export const LOCK_ACCOUNT = "LOCK_ACCOUNT";
export const LOGOUT_USER = "LOGOUT_USER";

// constants for Assets
export const GET_ALL_ASSETS = "GET_ALL_ASSETS";
export const GET_WELL_KNOWN_ASSETS = "GET_WELL_KNOWN_ASSETS";
export const GET_ASSET_INFO_BY_ID = "GET_ASSET_INFO_BY_ID";
export const SEARCH_ASSETS = "SEARCH_ASSETS";

// constants for accounts
export const GET_ACCOUNT_INFO_BY_ID = "GET_ACCOUNT_INFO_BY_ID";

// constants for user
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_ALL_ACCOUNTS_OF_USER = "GET_ALL_ACCOUNTS_OF_USER";
export const GET_ALL_CONTACTS_OF_USER = "GET_ALL_CONTACTS_OF_USER";
export const GET_USER_PREFERENCES = "GET_USER_PREFERENCES";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const GET_USER_NOTIFICATION_PREFERENCES = "GET_USER_NOTIFICATION_PREFERENCES";

// constants for transactions
export const GET_FIXED_INPUT_SWAP_QUOTE = "GET_FIXED_INPUT_SWAP_QUOTE";
export const GET_FIXED_OUTPUT_SWAP_QUOTE = "GET_FIXED_OUTPUT_SWAP_QUOTE";

// constants for loaders
export const BUILDING_COMPONENT = "BUILDING_COMPONENT";
export const BUILDING_APP = "BUILDING_APP";
export const UPDATING_DATA = "UPDATING_DATA";
export const FETCHING_DATA_FROM_API = "FETCHING_DATA_FROM_API";
export const SENDING_TRANSACTION = "SENDING_TRANSACTION";
export const LIVE_SEARCH_LOADING = "LIVE_SEARCH_LOADING";
export const INPUT_SWAP_QUOTE_LOADING = "INPUT_SWAP_QUOTE_LOADING";
